import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hoursFormat',
})
export class HoursFormatPipe implements PipeTransform {
  /**
   * Formats a number representing minutes into a human-readable hours and minutes format
   * @param minutes The number of minutes to format
   * @param formatType Optional parameter to specify the format type:
   *                  'decimal' - formats as decimal hours with specified decimal places (e.g., "3.08")
   *                  'hm' - formats as hours and minutes (e.g., "3h 5m") - this is the default
   * @param decimalPlaces The number of decimal places to display when using 'decimal' format (default: 2)
   * @returns The formatted time value
   */
  transform(minutes: number, formatType: 'decimal' | 'hm' = 'hm', decimalPlaces: number = 2): string {
    if (minutes === null || minutes === undefined || isNaN(minutes)) {
      return '';
    }

    if (formatType === 'decimal') {
      // Convert minutes to hours and format with specified decimal places
      const hours = minutes / 60;
      return hours.toFixed(decimalPlaces);
    } else {
      // Format as hours and minutes (e.g., "2h 30m")
      const hours = Math.floor(minutes / 60);
      const mins = Math.floor(minutes % 60);
      return `${hours}h ${mins}m`;
    }
  }
}
